import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PlanningDateService {
  private selectedPlanningDate = new BehaviorSubject<Date>(moment().toDate());

  constructor() {
    const storedPlanningDateString = localStorage.getItem('planningDate');
    this.selectedPlanningDate = new BehaviorSubject<Date>(
      storedPlanningDateString == null
        ? moment().toDate()
        : new Date(storedPlanningDateString)
    );
  }

  public getSelectedPlanningDateSubscribable(): BehaviorSubject<Date> {
    return this.selectedPlanningDate;
  }

  public setSelectedPlanningDate(date: moment.Moment) {
    this.selectedPlanningDate.next(date.toDate());
    localStorage.setItem('planningDate', date.utc().format());
  }

  public changeDay(amount: number) {
    const newDate = moment(this.selectedPlanningDate.value).add(amount, 'days');
    this.selectedPlanningDate.next(newDate.toDate());
    localStorage.setItem('planningDate', newDate.utc().format());
  }
}
